import { LuCalendar, LuFileCheck, LuFingerprint, LuLayoutDashboard, LuListChecks, LuPackage, LuPaperclip, LuSticker, LuStickyNote, LuUser, LuUsers, LuUsers2, LuView } from "react-icons/lu";
import { APP_URLS } from "../../config";

import { COMMON_MENU } from './common/common';
export const TEAM_LEAD_MENU = [
    ...COMMON_MENU,

    {
        title: 'Manage Prospects',
        icon: LuStickyNote,
        path: APP_URLS.PROSPECTS.ROUTES,
        hasSubMenu: false
    },
    {
        title: 'My Team',
        icon: LuUsers,
        hasSubMenu: true,
        submenu: [
            {
                title: 'Associates',
                path: APP_URLS.USERS.ROUTE,
                icon: LuFingerprint,
            },
            {
                title: 'Attendances',
                path: APP_URLS.ATTENDANCE.LIST,
                icon: LuListChecks
            },
            {
                title: 'Prospects',
                path: APP_URLS.PROSPECTS.ALL,
                icon: LuFileCheck,
            },
            {
                title: 'Leaves',
                path: APP_URLS.LEAVES.ALL,
                icon: LuPaperclip
            }
        ]
    },
    {
        title: 'Manage Sales',
        icon: LuSticker,
        hasSubMenu: true,
        submenu: [
            {
                title: 'All Accounts',
                path: APP_URLS.APPLICATION.ROUTE,
                icon: LuView
            },
            // {
            //     title: 'View Reports',
            //     path: APP_URLS.LEADS.REPORTS,
            //     icon: LuPackage
            // }
        ]
    }
]